import { useMemo, useState } from "react";
import { Check } from "lucide-react";
import { useGame } from "./useGame";
import { GameShell, cardCls } from "./GameShell";

const Board = ({ g, onResult }) => {
  const meanings = useMemo(() => [...g.pairs].sort(() => Math.random() - 0.5), [g]);
  const [word, setWord] = useState(null);
  const [done, setDone] = useState([]);
  const [wrong, setWrong] = useState(null);
  const [missed, setMissed] = useState([]);
  const pick = (id) => {
    if (!word || done.includes(id)) return;
    if (word !== id) { setMissed((m) => (m.includes(word) ? m : [...m, word])); setWrong(id); setTimeout(() => setWrong(null), 450); return; }
    const next = [...done, id]; setDone(next); setWord(null);
    if (next.length === g.pairs.length) onResult({ kind: "match", title: g.title, correct: g.pairs.length - missed.length, total: g.pairs.length });
  };
  return (
    <div data-testid="match-game">
      <p className="font-display text-xl text-[#2C4A3E]" data-testid="game-title">{g.title}</p>
      <p className="text-xs text-stone-500 mt-1">Tap a word, then tap what it means.</p>
      <div className="mt-4 grid grid-cols-2 gap-3">
        <div className="space-y-3">{g.pairs.map((p) => (
          <button key={p.id} type="button" disabled={done.includes(p.id)} onClick={() => setWord(word === p.id ? null : p.id)} data-testid={`match-word-${p.id}`} aria-pressed={word === p.id}
            className={`${cardCls(word === p.id)} w-full p-4 text-left flex items-center gap-3 disabled:opacity-50 disabled:bg-[#E1F1E7]`}>
            <span className="text-3xl leading-none" aria-hidden>{p.emoji}</span><span className="font-display text-lg">{p.word}</span>{done.includes(p.id) && <Check className="w-4 h-4 ml-auto text-[#2E7D4F]" />}</button>))}</div>
        <div className="space-y-3">{meanings.map((p) => (
          <button key={p.id} type="button" disabled={done.includes(p.id)} onClick={() => pick(p.id)} data-testid={`match-meaning-${p.id}`}
            className={`${cardCls(false, wrong === p.id)} w-full p-4 text-left text-sm min-h-[60px] disabled:opacity-50 disabled:bg-[#E1F1E7]`}>{p.meaning}</button>))}</div>
      </div>
    </div>
  );
};

export const MatchGame = ({ req, lesson, onResult }) => {
  const { g, err, load } = useGame("match", req, lesson);
  return <GameShell g={g} err={err} load={load}>{g && <Board g={g} onResult={onResult} />}</GameShell>;
};
